import { render, staticRenderFns } from "./OrganizationTree.vue?vue&type=template&id=0552861f&scoped=true"
import script from "./OrganizationTree.vue?vue&type=script&lang=js"
export * from "./OrganizationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552861f",
  null
  
)

export default component.exports